export const about = {
  story: '企業紹介',
  competency: 'コア・コンピテンシー',
  history: '会社沿革',
  people: 'ピープル',
  partner: 'パートナー',
  ci: 'CI'
};

export default about;
